import { render, staticRenderFns } from "./TimeItem2.vue?vue&type=template&id=2c64ec29"
import script from "./TimeItem2.vue?vue&type=script&lang=js"
export * from "./TimeItem2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports